import React from 'react';

const FeaturedPostSection = ({ selectedCategory, blogPosts }) => {
  const formatDate = (dateString) => {
    const options = { year: 'numeric', month: 'long', day: 'numeric' };
    return new Date(dateString).toLocaleDateString('en-US', options);
  };

  const featuredPosts = blogPosts.filter(post => post.featured);

  if (selectedCategory !== 'All' || featuredPosts.length === 0) {
    return null;
  }

  return (
    <section className="section-padding bg-light">
      <div className="container">
        <div className="text-center mb-5">
          <h2 className="section-title">Article en Vedette</h2>
          <p className="section-subtitle">Découvrez notre contenu le plus populaire</p>
        </div>
        {featuredPosts.map((post) => (
          <div key={post.id} className="row" data-aos="fade-up">
            <div className="col-lg-10 mx-auto">
              <div className="card featured-post shadow-lg border-0">
                <div className="row g-0">
                  <div className="col-md-6">
                    <img 
                      src={post.image} 
                      alt={post.title}
                      className="img-fluid h-100"
                      style={{ objectFit: 'cover' }}
                    />
                  </div>
                  <div className="col-md-6">
                    <div className="card-body p-5">
                      <div className="mb-3">
                        <span className="badge bg-primary me-2">{post.category}</span>
                        <span className="text-muted small">{post.readTime}</span>
                      </div>
                      <h2 className="card-title h3 mb-4">{post.title}</h2>
                      <p className="card-text mb-4">{post.excerpt}</p>
                      
                      {/* Additional featured content */}
                      <div className="featured-content mb-4">
                        <h6 className="text-primary mb-2">Points clés de cet article :</h6>
                        <ul className="list-unstyled">
                          <li className="mb-1"><i className="fas fa-check text-success me-2"></i>Stratégies éprouvées</li>
                          <li className="mb-1"><i className="fas fa-check text-success me-2"></i>Conseils pratiques</li>
                          <li className="mb-1"><i className="fas fa-check text-success me-2"></i>Exemples concrets</li>
                        </ul>
                      </div>
                      
                      <div className="d-flex align-items-center justify-content-between">
                        <div className="d-flex align-items-center">
                          <img 
                            src={`https://i.pravatar.cc/40?img=${post.author.split(' ')[0]}`}
                            alt={post.author}
                            className="rounded-circle me-3"
                            width="40"
                            height="40"
                          />
                          <div>
                            <small className="text-muted d-block">Par {post.author}</small>
                            <small className="text-muted">{formatDate(post.date)}</small>
                          </div>
                        </div>
                        <div className="text-end">
                          <div className="small text-muted mb-1">Partagé {post.shares ? post.shares : '0'} fois</div>
                          <div className="small text-muted">{post.views ? post.views.toLocaleString() : '0'} vues</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default FeaturedPostSection;
